import { RatingsHistoryDTO } from "../dto/RatingsHistoryDTO";
import { RatingHistory } from "../models/Person/RatingHistory";
import { ProgramTypes } from "../models/Person/Membership";
import { useUtility } from "@/composables/useUtility";

const { formatDateNY } = useUtility();

export const ratingsHistoryMapper = (dto: RatingsHistoryDTO) => {
  let action = "";
  switch (dto.action) {
    case "G":
      action = "Grant";
      break;
    case "R":
      action = "Rescind";
      break;
    default:
      action = "";
      break;
  }

  const { programId } = dto;

  return new RatingHistory({
    program: programId ? ProgramTypes[programId] : null,
    name: dto.ratingName || null,
    action: action,
    author: dto.changedBy || null,
    date: dto.changedDate ? formatDateNY(dto.changedDate) : null,
    comments: dto.comments || null,
  });
};
